import { Errno, Exception, withErrno } from 'kerium';
import { checkStruct, isStatic } from './internal.js';
import * as primitive from './primitives.js';
import { isType } from './types.js';
/**
 * Gets the size in bytes of a type
 */
export function sizeof(type) {
    if (isType(type))
        return type.size;
    if (type === undefined || type === null)
        return 0;
    if (typeof type == 'object' && isType(type.constructor))
        return type.constructor.size;
    if (Array.isArray(type)) {
        let size = 0;
        for (let i = 0; i < type.length; i++)
            size += sizeof(type[i]);
        return size;
    }
    // primitive or character
    if (typeof type == 'string') {
        primitive.checkValid(type);
        return primitive.types[primitive.normalize(type)].size;
    }
    // eslint-disable-next-line @typescript-eslint/no-base-to-string
    throw new TypeError(`Unable to resolve size of \`${type.toString()}\``);
}
/**
 * Returns the offset (in bytes) of a field in a struct.
 */
export function offsetof(type, fieldName) {
    checkStruct(type);
    const constructor = isStatic(type) ? type : type.constructor;
    const { fields } = constructor[Symbol.metadata].struct;
    if (!(fieldName in fields))
        throw withErrno('EINVAL', 'Struct does not have field: ' + fieldName);
    return fields[fieldName].offset;
}
export class MemoryError extends Exception {
    address;
    constructor(err, address) {
        super(Errno[err]);
        this.address = address;
    }
}
